import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

const HomeBenefits = () => (
  <StaticQuery
    query={graphql`
      query {
        child_care_shortened_time: file(
          relativePath: { eq: "benefits/child_care_shortened_time.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        flextime: file(relativePath: { eq: "benefits/flextime.png" }) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        child_care_time: file(
          relativePath: { eq: "benefits/child_care_time.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        reduced_overtime: file(
          relativePath: { eq: "benefits/reduced_overtime.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        remote_work: file(relativePath: { eq: "benefits/remote_work.png" }) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        staggered_commute_hours: file(
          relativePath: { eq: "benefits/staggered_commute_hours.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        in_office_childcare: file(
          relativePath: { eq: "benefits/in_office_childcare.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        barrier_free: file(relativePath: { eq: "benefits/barrier_free.png" }) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        menstrual_leave: file(
          relativePath: { eq: "benefits/menstrual_leave.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        infertility_treatment_leave: file(
          relativePath: { eq: "benefits/infertility_treatment_leave.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        maternity_leave_before: file(
          relativePath: { eq: "benefits/maternity_leave_before.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        child_care_leave: file(
          relativePath: { eq: "benefits/child_care_leave.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        child_care_leave_of_absence: file(
          relativePath: { eq: "benefits/child_care_leave_of_absence.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        paternity_leave: file(
          relativePath: { eq: "benefits/paternity_leave.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        child_care_allowance: file(
          relativePath: { eq: "benefits/child_care_allowance.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        child_rearing_allowance: file(
          relativePath: { eq: "benefits/child_rearing_allowance.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        daycare_allowance: file(
          relativePath: { eq: "benefits/daycare_allowance.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className="row mx-0 mt-5 home-benefits">
        <div className="col-12 home-benefits-header px-0">
          18,000社以上の働き方情報を無料公開中！
        </div>
        <div className="col-12 home-benefits-content">
          {/* 働く時間で企業を探す */}
          <div className="benefit-title">
            <span className="text-green">働く時間</span>で企業を探す
          </div>
          <div className="row mx-0">
            {/* 時短勤務 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/shorter-work-hour/">
                {/* <img alt="時短勤務" srcSet={data.child_care_shortened_time.childImageSharp.fixed.srcSet} /> */}
                <Img
                  fluid={data.child_care_shortened_time.childImageSharp.fluid}
                />
                <div className="text-green">
                  <small>時短勤務</small>
                </div>
              </Link>
            </div>
            {/* フレックス */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/flexible-work-hour/">
                {/* <img alt="フレックス" srcSet={data.flextime.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.flextime.childImageSharp.fluid} />
                <div className="text-green">
                  <small>フレックス</small>
                </div>
              </Link>
            </div>
            {/* 看護休暇 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/nursing-care-leave/">
                {/* <img alt="看護休暇" srcSet={data.child_care_time.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.child_care_time.childImageSharp.fluid} />
                <div className="text-green">
                  <small>看護休暇</small>
                </div>
              </Link>
            </div>
            {/* 残業削減 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/reduced-overtime-work/">
                {/* <img alt="残業削減" srcSet={data.reduced_overtime.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.reduced_overtime.childImageSharp.fluid} />
                <div className="text-green">
                  <small>残業削減</small>
                </div>
              </Link>
            </div>
            <div className="col-md-2 col-6 text-center col-benefit col-benefit-blank" />
            <div className="col-md-2 col-6 text-center col-benefit col-benefit-blank" />
          </div>

          {/* 働く場所・環境で企業を探す */}
          <div className="benefit-title">
            <span className="text-green">働く場所・環境</span>で企業を探す
          </div>
          <div className="row mx-0">
            {/* リモートワーク */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/remote-work/">
                {/* <img alt="リモートワーク" srcSet={data.remote_work.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.remote_work.childImageSharp.fluid} />
                <div className="text-green">
                  <small>リモートワーク</small>
                </div>
              </Link>
            </div>
            {/* 時差Biz */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/staggered-commuting/">
                {/* <img alt="時差Biz" srcSet={data.staggered_commute_hours.childImageSharp.fixed.srcSet} /> */}
                <Img
                  fluid={data.staggered_commute_hours.childImageSharp.fluid}
                />
                <div className="text-green">
                  <small>時差Biz</small>
                </div>
              </Link>
            </div>
            {/* 企業内保育所 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/childcare-center/">
                {/* <img alt="企業内保育所" srcSet={data.in_office_childcare.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.in_office_childcare.childImageSharp.fluid} />
                <div className="text-green">
                  <small>企業内保育所</small>
                </div>
              </Link>
            </div>
            {/* バリアフリー */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/barrior-free/">
                {/* <img alt="バリアフリー" srcSet={data.barrier_free.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.barrier_free.childImageSharp.fluid} />
                <div className="text-green">
                  <small>バリアフリー</small>
                </div>
              </Link>
            </div>
            <div className="col-md-2 col-6 text-center col-benefit col-benefit-blank" />
            <div className="col-md-2 col-6 text-center col-benefit col-benefit-blank" />
          </div>

          {/* 休暇・休業で企業を探す */}
          <div className="benefit-title">
            <span className="text-green">休暇・休業</span>で企業を探す
          </div>
          <div className="row mx-0">
            {/* 生理休暇 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/menstrual-leave/">
                {/* <img alt="生理休暇" srcSet={data.menstrual_leave.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.menstrual_leave.childImageSharp.fluid} />
                <div className="text-green">
                  <small>生理休暇</small>
                </div>
              </Link>
            </div>
            {/* 不妊治療休職 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/fertility-treatment-leave/">
                {/* <img alt="不妊治療休職" srcSet={data.infertility_treatment_leave.childImageSharp.fixed.srcSet} /> */}
                <Img
                  fluid={data.infertility_treatment_leave.childImageSharp.fluid}
                />
                <div className="text-green">
                  <small>不妊治療休職</small>
                </div>
              </Link>
            </div>
            {/* 産前・産後休業 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/maternity-leave/">
                {/* <img alt="産前・産後休業" srcSet={data.maternity_leave_before.childImageSharp.fixed.srcSet} /> */}
                <Img
                  fluid={data.maternity_leave_before.childImageSharp.fluid}
                />
                <div className="text-green">
                  <small>産前・産後休業</small>
                </div>
              </Link>
            </div>
            {/* 育児休暇 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/childcare-leave/">
                {/* <img alt="育児休暇" srcSet={data.child_care_leave.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.child_care_leave.childImageSharp.fluid} />
                <div className="text-green">
                  <small>育児休暇</small>
                </div>
              </Link>
            </div>
            {/* 育児休業 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/childcare-paid-leave/">
                {/* <img alt="育児休業" srcSet={data.child_care_leave_of_absence.childImageSharp.fixed.srcSet} /> */}
                <Img
                  fluid={data.child_care_leave_of_absence.childImageSharp.fluid}
                />
                <div className="text-green">
                  <small>育児休業</small>
                </div>
              </Link>
            </div>
            {/* 男性の育休 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/childcare-leave-men/">
                {/* <img alt="男性の育休" srcSet={data.paternity_leave.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.paternity_leave.childImageSharp.fluid} />
                <div className="text-green">
                  <small>男性の育休</small>
                </div>
              </Link>
            </div>
          </div>

          {/* 支援金・補助で企業を探す */}
          <div className="benefit-title">
            <span className="text-green">支援金・補助</span>で企業を探す
          </div>
          <div className="row mx-0">
            {/* 育児支援金 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/childcare-financial-support/">
                {/* <img alt="育児支援金" srcSet={data.child_care_allowance.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.child_care_allowance.childImageSharp.fluid} />
                <div className="text-green">
                  <small>育児支援金</small>
                </div>
              </Link>
            </div>
            {/* ベビーシッター */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/baby-sitter/">
                {/* <img alt="ベビーシッター" srcSet={data.child_rearing_allowance.childImageSharp.fixed.srcSet} /> */}
                <Img
                  fluid={data.child_rearing_allowance.childImageSharp.fluid}
                />
                <div className="text-green">
                  <small>ベビーシッター</small>
                </div>
              </Link>
            </div>
            {/* 保育施設補助 */}
            <div className="col-md-2 col-6 text-center col-benefit">
              <Link to="/benefit/childcare-facility-support/">
                {/* <img alt="保育施設補助" srcSet={data.daycare_allowance.childImageSharp.fixed.srcSet} /> */}
                <Img fluid={data.daycare_allowance.childImageSharp.fluid} />
                <div className="text-green">
                  <small>保育施設補助</small>
                </div>
              </Link>
            </div>
            <div className="col-md-2 col-6 text-center col-benefit col-benefit-blank" />
            <div className="col-md-2 col-6 text-center col-benefit col-benefit-blank" />
            <div className="col-md-2 col-6 text-center col-benefit col-benefit-blank" />
          </div>
        </div>
      </div>
    )}
  />
);

export default HomeBenefits;
